import { IntentType } from '@debbie/common/dist/intents/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { getErrorMessage } from '../../utils/errors.js';
import Button from '../Button.js';
import Errors from '../Errors.js';
import Eye from '../Icons/Eye.js';
import FileText from '../Icons/FileText.js';
import Paperclip from '../Icons/Paperclip.js';
import SendIcon from '../Icons/Send.js';
import Target from '../Icons/Target.js';
import UserPlus from '../Icons/UserPlus.js';
export const DEFAULT_TOOLTIP_ID = 'tooltip-default';
export const DEFAULT_INTENT = {
    type: IntentType.Deposit,
    collectionPeriod: 10,
};
const InteractionFooter = ({ primary, actions, error, className, }) => {
    const lang = useSelector((s) => s.lang);
    const message = getErrorMessage(error);
    const failure = `${lang.misc.errorCreating} ${lang.errorEntities.interaction}`;
    return (React.createElement(React.Fragment, null,
        error != null && (React.createElement("div", { role: "alert" },
            React.createElement(Errors, { errors: [message != null ? `${failure}: ${message}` : failure] }))),
        React.createElement(Footer, { className: className },
            React.createElement(FooterPrimary, null, primary),
            actions ? React.createElement(FooterActions, null, actions) : null)));
};
export default InteractionFooter;
export const AttachAction = ({ onClick, label, disabled, className, }) => {
    const fallback = useSelector((s) => s.lang.interactions.addFiles);
    return (React.createElement(FooterAction, { onClick: onClick, disabled: disabled, title: label ?? fallback, className: className },
        React.createElement(Paperclip, null)));
};
export const PreviewAction = ({ onClick, label, disabled, className, }) => {
    const fallback = useSelector((s) => s.lang.interactions.preview);
    const text = label ?? fallback;
    return (React.createElement(IconAction, { type: "button", onClick: onClick, disabled: disabled, "aria-label": text, className: className },
        React.createElement(Eye, null),
        React.createElement("span", null, text)));
};
export const AddTemplateAction = ({ onClick, disabled, }) => {
    const title = useSelector((s) => s.lang.interactions.addTemplate);
    return (React.createElement(FooterAction, { onClick: onClick, disabled: disabled, title: title },
        React.createElement(FileText, null)));
};
export const AddDebtorDocumentsAction = ({ documents, onAdd, }) => {
    const baseTitle = useSelector((s) => s.lang.interactions.addDebtorDocuments);
    const files = (documents || [])
        .map((d) => d.file)
        .filter((f) => f != null);
    if (!files.length) {
        return null;
    }
    return (React.createElement(FooterAction, { onClick: () => onAdd(files), title: `${baseTitle} (${files.length})` },
        React.createElement(UserPlus, null)));
};
export const AddIntentAction = ({ onAdd, disabled, }) => {
    const title = useSelector((s) => s.lang.interactions.addIntent);
    return (React.createElement(FooterAction, { onClick: () => onAdd(DEFAULT_INTENT), disabled: disabled, title: title },
        React.createElement(Target, null)));
};
export const SendButton = ({ onClick, loading, disabled, children, id, className, }) => (React.createElement(Button, { size: "small", loading: loading, disabled: disabled, onClick: onClick, id: id, className: className },
    React.createElement(SendButtonContent, null,
        children,
        React.createElement(SendIcon, null))));
export const FooterAction = ({ onClick, title, disabled, className, children, }) => (React.createElement(IconAction, { type: "button", onClick: onClick, disabled: disabled, "aria-label": title, "data-tooltip-id": DEFAULT_TOOLTIP_ID, "data-tooltip-content": title, className: className }, children));
const Footer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0 0 0;
`;
const FooterPrimary = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;
const FooterActions = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;
const SendButtonContent = styled.span `
  display: inline-flex;
  align-items: center;
  gap: 6px;

  svg {
    width: 14px;
    height: 14px;
    transform: translateY(-1px);
  }
`;
const IconAction = styled.button `
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  padding: 6px 10px;
  border-radius: 6px;
  color: ${THEME.COLOR_PRIMARY};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    opacity 0.15s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover:not(:disabled) {
    background: rgba(117, 104, 246, 0.08);
    color: ${THEME.COLOR_ACCENT};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${THEME.COLOR_ACCENT};
    outline-offset: 1px;
  }
`;
//# sourceMappingURL=InteractionFooter.js.map